import { uid } from 'radash';

import { ComponentInstanceHelpers } from '@diagram/helpers/ComponentInstanceHelpers';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    PortControlMethod,
} from 'models';

const converterControlMethods: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const { componentInstances } = diagram;

    const errors: ComponentInstanceValidationError[] = [];

    Object.values(componentInstances).map((componentInstance) => {
        const error = (type: ComponentInstanceValidationError['type']) => {
            errors.push({ type, level: 'error', payload: { componentInstance }, id: uid(6) });
        };

        const definition = ComponentInstanceHelpers.definition(componentInstance.componentType);
        const { actsAsConverter } = definition;
        const { allowedControlMethods = [] } = definition.ports;

        if (!componentInstance.disabled && actsAsConverter && allowedControlMethods.length > 0) {
            const connections = Object.values(diagram.connections).filter(
                (c) =>
                    c.from.componentInstanceId === componentInstance.id ||
                    c.to.componentInstanceId === componentInstance.id,
            );

            const controlMethods: (PortControlMethod | null)[] = [];

            connections.forEach((connection) => {
                const { port } =
                    connection.from.componentInstanceId === componentInstance.id ? connection.from : connection.to;

                if (port === null) return;

                const { controlMethod } = componentInstance.configuration.ports[port];

                controlMethods.push(controlMethod);
            });

            const numberOfUncontrolledPorts = controlMethods.filter(
                (controlMethod) => controlMethod === null || controlMethod === 'uncontrolled',
            ).length;

            const appliesMpptWithPowerVoltageControl =
                controlMethods.length === 2 &&
                controlMethods.includes('maximum-power-point-tracking') &&
                controlMethods.includes('power-voltage');

            if (appliesMpptWithPowerVoltageControl) {
                return;
            }

            if (numberOfUncontrolledPorts === 0 && connections.length > 1) {
                error(ComponentInstanceValidationErrorType.CONTROL_METHODS_TOO_MANY);
            } else if (numberOfUncontrolledPorts > 1) {
                error(ComponentInstanceValidationErrorType.CONTROL_METHODS_MISSING);
            }
        }
    });

    return errors;
};

export { converterControlMethods };
